export const success = {
    100: '#F1FDE8',
    300: '#DFFBCC',
    500: '#C0F79F',
    700: '#98EF67',
    900: '#74E239',
    1000: '#52C41A',
    main: '#52C41A',
    1100: '#3D9F11',
    1300: '#317912',
    1500: '#2A6014',
    1700: '#265116',
};

export const warning = {
    100: '#FFFCEB',
    300: '#FFF6C6',
    500: '#FFEB88',
    700: '#FFDC49',
    900: '#FFC920',
    1000: '#FAAD14',
    main: '#FAAD14',
    1100: '#DD7F02',
    1300: '#B75A06',
    1500: '#95440B',
    1700: '#7A380D',
};

export const error = {
    100: '#FFF0F1',
    300: '#FFDEE0',
    500: '#FFC3C6',
    700: '#FF999E',
    900: '#FF5F67',
    1000: '#FF2D38',
    main: '#FF2D38',
    1100: '#F5222D',
    1300: '#CE0711',
    1500: '#AA0A12',
    1700: '#8C1016',
};

export const information = {
    100: '#EDFAFF',
    300: '#D7F1FF',
    500: '#B9E8FF',
    700: '#88DDFF',
    900: '#50C7FF',
    1000: '#28A9FF',
    main: '#28A9FF',
    1100: '#1890FF',
    1300: '#0A73EB',
    1500: '#0F5CBE',
    1700: '#135095',
};
